import React, { memo } from 'react'
import './Button.scss'

const Button = (props) => {
  const { id, children, className = 'btn-primary', onClick, disabled } = props
  return <button id={id} type='button' className={`btn ${className}`} onClick={onClick} disabled={disabled}> {children} </button>
}
export default memo(Button)
